import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import { PanelsLogTable } from "../../../UI/Panels/Log";

const PanelsLog = () => {
  return (
    <div>
      <PanelHead title="PanelsLog" />
      <PanelBody content={<PanelsLogTable />} />
    </div>
  );
};

export default React.memo(PanelsLog);
